export default __webpack_public_path__ + "static/logo-c059a1b22147b88d825fbbd94be0c276.svg";